import type { SceneNodeId } from '../../scene/sceneState.js';
import type { ViewportMode } from '../../state/appState.js';

export interface ViewportClickPolicyInput {
  mode: ViewportMode;
  pickedNodeId: SceneNodeId | null;
  ownerComponentId: string | null;
  activeComponentId: string | null;
  selectedSceneNodeId: SceneNodeId | null;
  selectedSceneNodeComponentId: string | null;
  rootIds: readonly SceneNodeId[];
  pickedSelectedInstance: boolean;
}

export interface ViewportClickPolicy {
  isBackground: boolean;
  drillIntoPickedInstance: boolean;
  stepOutToScene: boolean;
  syncOwnerContext: boolean;
}

export function resolveViewportClickPolicy(input: ViewportClickPolicyInput): ViewportClickPolicy {
  const isIsolated = input.mode === 'isolation';
  const isBackground = input.pickedNodeId === null || input.rootIds.includes(input.pickedNodeId);
  const selectedSameOwner = input.selectedSceneNodeComponentId === input.ownerComponentId;
  const selectedSameNode = !!input.pickedNodeId && input.pickedNodeId === input.selectedSceneNodeId;

  return {
    isBackground,
    drillIntoPickedInstance: !isIsolated && selectedSameNode && selectedSameOwner && input.pickedSelectedInstance,
    stepOutToScene: !isIsolated
      && isBackground
      && !!input.activeComponentId
      && input.ownerComponentId === input.activeComponentId,
    syncOwnerContext: input.ownerComponentId !== input.activeComponentId && (!isIsolated || !isBackground),
  };
}
